import classNames from 'classnames';
import React from 'react'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'
import { Link } from 'gatsby'
import parser from 'html-react-parser'
import {

    leftSec,
    btn,
    smCenter,


} from './Content5.module.css';
export default function Content5({ data }) {
    const { content5FirstButtonEmailLink, content5FirstButtonText, content5FirstButtonInternalLink, content5FirstButtonType, content5Title, content5Text, content5Subtitile, content5SecondButtonText, content5SecondButtonLink, content5Image, content5BackgroundColor, content5FirstButtonColor, content5FirstButtonExternalLink, content5SecondButtonExternalLink, content5ReverseRow } = data

    console.log('color', content5FirstButtonColor)

    const buttonColor = content5FirstButtonColor === 'white' ? 'blue-outline-btn' : 'blue-btn'
    return (
        <div className={`image-radius-wrap about-our-team-sec light-${content5BackgroundColor}-bg`}>
            <div className={classNames('container', smCenter)}>
            <div className={classNames('row', content5ReverseRow)}>
                    <div className='col-md-7'>
                        <div className={classNames('c-5-left-sec', leftSec)}>
                            <h2 className='heading-level-2 blue-color'>{content5Title && parser(content5Title)}</h2>
                            <p>
                                <strong>{content5Subtitile && parser(content5Subtitile)}</strong>
                            </p>
                            <div className={`image-radius-patrn-1 ${content5BackgroundColor}-circle-ptrn-col hide-desk`}>
                                <GatsbyImage
                                    image={getImage(content5Image?.localFile)}
                                    alt='image'
                                />
                            </div>

                            {content5Text && parser(content5Text)}

                            {content5FirstButtonType == 'internal' && (content5FirstButtonInternalLink && (
                                <Link
                                    to={content5FirstButtonInternalLink.uri}
                                    className={`btn ${buttonColor}`}
                                >
                                    {content5FirstButtonText}
                                </Link>
                            )) || content5FirstButtonType == 'email' && (
                                content5FirstButtonEmailLink && <a
                                    href={`mailto:${content5FirstButtonEmailLink}`}
                                    className={`btn ${buttonColor}`}
                                >
                                    {content5FirstButtonText}
                                </a>
                            ) || content5FirstButtonType == 'external' && (
                                content5FirstButtonExternalLink && (
                                    <a href={content5FirstButtonExternalLink} className={`btn ${buttonColor}`}>
                                        {content5FirstButtonText}
                                    </a>
                                )
                            )}
                            {content5SecondButtonExternalLink ? (
                                <a href={content5SecondButtonExternalLink} className={classNames('btn', 'blue-btn', btn)}>
                                    {content5SecondButtonText}
                                </a>
                            ) : content5SecondButtonLink ? (
                                <Link to={content5SecondButtonLink.uri} className={classNames('btn', 'blue-btn', btn)}>
                                    {content5SecondButtonText}
                                </Link>
                            ) : null}
                        </div>
                    </div>
                    <div className='col-md-5'>
                        <div className={`image-radius-patrn-1 ${content5BackgroundColor}-circle-ptrn-col hide-mobile`}>
                            <GatsbyImage
                                image={getImage(content5Image?.localFile)}
                                alt='image'
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
